export function FilterField({ id, label, children }) {
  return (
    <div>
      <label htmlFor={id}>{label}</label>
      {children}
    </div>
  );
}

export default function FilterBar({ onSubmit, onReset, children }) {
  return (
    <form className="bw-filter-bar" onSubmit={onSubmit}>
      {children}
      <div className="bw-filter-actions">
        <button type="submit" className="btn btn-outline-primary">
          Search
        </button>
        <button type="button" className="btn btn-outline-secondary" onClick={onReset}>
          Reset
        </button>
      </div>
    </form>
  );
}
